/**
 * Chrome manifest for the Tracking Profiles app.
 *
 * Data only — no imports of pages, routes, or anything that reaches a
 * component. The shell imports this eagerly to label the topbar and build
 * breadcrumbs, so a single component reference here would pull the whole app
 * into the initial bundle and defeat the lazy mount.
 */ export const BASE_PATH = '/opportunities/tracking-profiles';
export const trackingProfilesManifest = {
    id: 'tracking-profiles',
    basePath: BASE_PATH,
    meta: [
        {
            path: BASE_PATH,
            title: 'Tracking Profiles',
            description: 'Manage your tracking profiles'
        },
        {
            path: `${BASE_PATH}/create`,
            title: 'Create Tracking Profile',
            description: 'Define criteria for automatic opportunity discovery'
        },
        {
            path: `${BASE_PATH}/:id`,
            title: 'Tracking Profile',
            description: 'Profile criteria and matched opportunities'
        },
        {
            path: `${BASE_PATH}/:id/edit`,
            title: 'Edit Tracking Profile',
            description: 'Update profile criteria'
        }
    ],
    crumbs: {
        'tracking-profiles': 'Tracking Profiles'
    }
};
